import { useCallback } from "react";
import { useTranslatedFieldUpdate } from "./ViewerLayoutHooks";
import { viewerMapping, viewerType } from "./ViewerLayoutTypes";
import { globalViewerState } from "./useViewerState";
import { SpectrumComponent, SpectrumComponent2D } from "../SpectrumViewer/SpectrumComponent";
import { ImageComponent } from "../Images/ImageComponent";
import { MoleculeComponent } from "../Images/MoleculeComponent";
import { TableComponent } from "../TableViewer/TableComponent";
import { PDFComponent } from "../PDFViewer/PDFComponent";

export const CoreViewer = (props: globalViewerState) => {
  const { activeViewer } = props.state;

  const viewer = useTranslatedFieldUpdate(
    activeViewer,
    (activeViewer: viewerType | undefined) => viewerMapping[activeViewer ?? "unknown"],
    undefined
  );

  const v = useCallback(
    (props: globalViewerState) => {
      switch (viewer) {
        case "SpectrumComponent":
          return <SpectrumComponent {...props} />;
        case "SpectrumComponent2D":
          return <SpectrumComponent2D {...props} />;
        case "ImageComponent":
          return <ImageComponent {...props} />;
        case "MoleculeComponent":
          return <MoleculeComponent {...props} />;
        case "PDFComponent":
          return <PDFComponent {...props} />;
        case "TableComponent":
          return <TableComponent {...props} />;
        default:
          return <>Viewer component "{viewer}" is unknown!</>;
      }
    },
    [viewer]
  );

  return v(props);
};
